import getLocaleLink from './getLocaleLink';

import type { LinkHTMLAttributes } from 'react';

import type { Locale } from '../i18n/language';

interface GetCanonicalsProps {
  page?: string;
  locale: Locale;
}

export default function getCanonincals({ page, locale }: GetCanonicalsProps):
React.DetailedHTMLProps<LinkHTMLAttributes<HTMLLinkElement>, HTMLLinkElement>[] {
  return [
    // Canonical URL
    {
      rel: 'canonical',
      href: getLocaleLink({ page, locale }),
    },
    // Alternate language versions
    {
      rel: 'alternate',
      hrefLang: 'nl',
      href: getLocaleLink({ page, locale: 'nl' }),
    },
    {
      rel: 'alternate',
      hrefLang: 'en',
      href: getLocaleLink({ page, locale: 'en' }),
    },
  ];
}
